import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { DragAndDropUtils } from './dnd-upload.utils';
import { DndItem } from './dnd-item';

@Component({
  selector: 'tca-dnd-upload',
  templateUrl: './dnd-upload.component.html',
  styleUrls: ['./dnd-upload.component.scss']
})
export class DndUploadComponent implements OnInit {
  @ViewChild('inputUpload', null) private inputUpload: ElementRef;

  @Input() viewportHeight = '260px';
  @Input() imageHeight = '165px';
  @Input() imageWidth = '300px';
  @Input() deleteIcon = '';
  @Input() allowedExtensions: Array<string> = ['jpg', 'jpeg', 'png'];
  @Input() maxItems = 100;
  @Input() language = 'en';
  @Input() disabled = false;

  @Output() invalidFileChange: EventEmitter<File[]> = new EventEmitter();
  @Output() modelChange: EventEmitter<Array<any>> = new EventEmitter();

  modelValue: Array<DndItem> = [];

  @Input() get model(): Array<DndItem> { return this.modelValue; }

  set model(value: Array<DndItem>) {
    this.modelValue = value;
    this.modelChange.emit(this.modelValue);
  }

  get uploadedFiles() {
    return this.model.filter(x => x.url !== undefined);
  }

  get filesToUpload() {
    return this.model.filter(x => x.file !== undefined);
  }

  guid = DragAndDropUtils.newGuid();

  constructor() { }

  ngOnInit() {
  }

  getItemFilename(item: DndItem) {
    if (item.file !== undefined) {
      return item.file.name;
    }

    if (item.url !== undefined) {
      const urlArray = item.url.split('/');
      return urlArray[urlArray.length - 1];
    }

    return '';
  }

  onValidFilesChange(files: Array<File>) {
    if (this.disabled) {
      return;
    }

    files.forEach((f, i, a) => {
      // remove if repeated
      this.model = this.model.filter(x => {
        return this.getItemFilename(x) !== f.name;
      });

      const timestamp = `${Math.round((new Date()).getTime())}`;
      const reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = e => {
        if (this.maxItems === 0) {
          this.model = [];
          return;
        }

        if (this.model.length === this.maxItems) {
            this.model.pop();
        } else if (this.model.length > this.maxItems) {
          while(this.model.length !== this.maxItems - 1) {
            this.model.pop();
          }
        }

        this.model.push({
          id: timestamp,
          blob: reader.result.toString(),
          file: f
        });
      };
    });
  }

  onInvalidFilesChange(files: Array<File>) {
    if (this.disabled) {
      return;
    }

    this.invalidFileChange.emit(files);
  }

  onClickDelete(item: DndItem) {
    if (this.disabled) {
      return;
    }

    this.model = this.model.filter(x => this.getItemFilename(x) !== this.getItemFilename(item));
  }

  onInputUpload(event) {
    const files = event.target.files;
    if (files.length > 0) {
      const separatedFiles = DragAndDropUtils.separateValidInvalidFiles(this.allowedExtensions, files);
      this.onValidFilesChange(separatedFiles.valid);
      this.onInvalidFilesChange(separatedFiles.invalid);
      this.inputUpload.nativeElement.value = '';
    }
  }

  deleteAll() {
    this.model = [];
  }

  openPreview(item: DndItem) {
    if (this.disabled) {
      return;
    }

    const win = window.open();
    win.document.title = this.getItemFilename(item);

    const src = item.url ? item.url : item.blob;
    win.document.body.innerHTML = `
      <img src="${src}">
    `;
  }

  get uploadMessageFirst() {
    switch (this.language) {
      case 'es':
        return 'Arrastra tus imÃ¡genes o haz clic';
      default:
        return 'Drag and drop your images or click';
    }
  }

  get uploadMessageHere() {
    switch (this.language) {
      case 'es':
        return 'aquÃ­';
      default:
        return 'here';
    }
  }

  get uploadMessageLast() {
    switch (this.language) {
      case 'es':
        return 'para navegar';
      default:
        return 'to browse';
    }
  }

  get noImagesMessage() {
    switch (this.language) {
      case 'es':
        return 'No hay imÃ¡genes para mostrar';
      default:
        return 'No images to show';
    }
  }
}
